function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 34,
  width: 57,
  y: -1,
  x: -1
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("path", {
  id: "svg_1",
  d: "m25.569469,24.957921l-0.214,-0.098l-12.7,-5.782l0,5.311c0,2.355 5.782,5.855 12.914,5.855c7.132,0 12.914,-3.501 12.914,-5.855l0,-5.311l-12.914,5.88z"
}), React.createElement("polygon", {
  id: "svg_2",
  points: "25.569468021392822,0.19892024993896484 0.2524685859680176,11.724920272827148 25.569468021392822,23.249919891357422 50.88446855545044,11.724920272827148 "
}), React.createElement("path", {
  id: "svg_3",
  d: "m50.428469,21.019921l-0.002,-0.126c0.534,-0.339 0.944,-0.996 0.944,-1.679c0,-0.956 -0.623,-1.789 -1.57,-1.939l0,-5.551l-0.503,0l0,5.582c-0.885,0.214 -1.62,0.954 -1.62,1.846c0,0.683 0.259,1.278 0.793,1.617l-0.054,0.249l-1.873,7.79l2.855,0l2.854,0l-1.824,-7.789z"
}));

var SvgEduicon = function SvgEduicon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 55,
    height: 32,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEduicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eduicon.a951a691.svg";
export { ForwardRef as ReactComponent };